<template>
    <div class>
        <el-card class="box-card" shadow="hover">
            <div style="margin-bottom: 20px;">
                <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
            </div>
            <el-form
                :inline="true"
                :model="agentForm"
                label-position="right"
                label-width="140px"
            >
			<!-- 基本信息 -->
			<template>
			    <div class="m-title">基本信息</div>
			    <el-form-item label="交易结果" prop="tradeResult">
			        <el-input
			            size="medium"
			            suffix-icon="el-icon-aux"
			            v-model="agentForm.tradeResult"
			            placeholder="请输入交易结果"
			        ></el-input>
			    </el-form-item>
			    <el-form-item label="商户简称" prop="mercName">
			        <el-input
			            size="medium"
			            suffix-icon="el-icon-aux"
			            v-model="agentForm.mercName"
			            placeholder="请输入商户简称"
			        ></el-input>
			    </el-form-item>
				<br>
				<el-form-item label="法人姓名" prop="legalPerson">
				    <el-input
				        size="medium"
				        suffix-icon="el-icon-aux"
				        v-model="agentForm.legalPerson"
				        placeholder="请输入法人姓名"
				    ></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="linkPhone">
				    <el-input
				        size="medium"
				        suffix-icon="el-icon-aux"
				        v-model="agentForm.linkPhone"
				        placeholder="请输入联系电话"
				    ></el-input>
				</el-form-item>
				<el-form-item label="补充说明" prop="replenish">
				    <el-input
				        size="medium"
				        suffix-icon="el-icon-aux"
				        v-model="agentForm.replenish"
				        placeholder="请输入补充说明"
				    ></el-input>
				</el-form-item>
			</template>
                <!-- 资质信息 -->
                <template>
                    <div class="m-title">资质信息[每个类别最多上传4张]</div>
                    <div v-loading="imgLoading" element-loading-text="图片上传中,请稍等....">
                        <el-form-item label="签购单文件" prop="billInfoImgs" >
                            <el-upload
								style="display: contents;"
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handlebillInfoImgsImg"
                            >
						    <img :src="require('../../assets/images/other3x.png')" class="avatar">
                            </el-upload>
							<img v-for="(item,index) in agentForm.billInfoImgs" :src="item" class="avatar-uploader" style="margin-left:10px ;" @click="deletebillInfoImgs(index)">
                        </el-form-item>
						<br>
                        <el-form-item label="交易证明" prop="tradeProImgs">
                            <el-upload
								style="display: contents;"
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handletradeProImgsImg"
                            >
						        <img :src="require('../../assets/images/other3x.png')" class="avatar">
                            </el-upload>
							<img v-for="(item,index) in agentForm.tradeProImgs" :src="item" class="avatar-uploader" style="margin-left:10px ;" @click="deletetradeProImgs(index)">
                        </el-form-item>
                        <br />
                        <el-form-item label="交易卡正面照片" prop="tradeCardFrontImgs">
                            <el-upload
								style="display: contents;"
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handletradeCardFrontImgsImg"
                            >
						        <img :src="require('../../assets/images/other3x.png')" class="avatar">
                            </el-upload>
							<img v-for="(item,index) in agentForm.tradeCardFrontImgs" :src="item" class="avatar-uploader" style="margin-left:10px ;" @click="deletetradeCardFrontImgs(index)">
                        </el-form-item>
						<br>
                        <el-form-item label="交易卡反面照片" prop="tradeCardBackImgs">
                            <el-upload
								style="display: contents;"
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handletradeCardBackImgsImg"
                            >
						        <img :src="require('../../assets/images/other3x.png')" class="avatar">
                            </el-upload>
							<img v-for="(item,index) in agentForm.tradeCardBackImgs" :src="item" class="avatar-uploader" style="margin-left:10px ;" @click="deletetradeCardBackImgs(index)">
                        </el-form-item>
						<br>
						<el-form-item label="身份证正面照片" prop="certificateFrontImgs">
						    <el-upload
								style="display: contents;"
						        class="avatar-uploader"
						        :action="uploadUrl"
						        :show-file-list="false"
						        :on-progress="handleImgLoading"
						        :on-success="handlecertificateFrontImgsImg"
						    >
						        <img :src="require('../../assets/images/other3x.png')" class="avatar">
						    </el-upload>
							<img v-for="(item,index) in agentForm.certificateFrontImgs" :src="item" class="avatar-uploader" style="margin-left:10px ;" @click="deletecertificateFrontImgs(index)">
						</el-form-item>
						<br>
						<el-form-item label="身份证反面照片" prop="certificateBackImgs">
						    <el-upload
								style="display: contents;"
						        class="avatar-uploader"
						        :action="uploadUrl"
						        :show-file-list="false"
						        :on-progress="handleImgLoading"
						        :on-success="handlecertificateBackImgsImg"
						    >
						        <img :src="require('../../assets/images/other3x.png')" class="avatar">
						    </el-upload>
							<img v-for="(item,index) in agentForm.certificateBackImgs" :src="item" class="avatar-uploader" style="margin-left:10px ;" @click="deletecertificateBackImgs(index)">
						</el-form-item>
                    </div>
                </template>
            </el-form>
            <div style="margin-top:20px">
                <el-button
                    type="primary"
                    :loading="loading"
                    style="font-size: 12px;"
                    @click="handleSubmit(agentForm)"
                >提交</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
			uploadUrl: this.$api.uploadUrl, // 上传图片的地址
			loading: false, // 提交loading
			imgLoading: false, // 上传图片loading
            agentForm: {
				type:"DispatchOrderData",
				tradeResult:'',
				mercName:'',
				legalPerson:'',
				linkPhone:'',
				replenish:'',
				dispatchNum:this.$route.query.caseNo,
				billInfoImgs:[],//签购单文件
				tradeProImgs:[],//交易证明
				tradeCardFrontImgs:[],//交易卡正面照片
				tradeCardBackImgs:[],//交易卡反面照片
				certificateFrontImgs:[],//身份证正面照片
				certificateBackImgs:[],//身份证反面照片
            },
        }
    },
    watch: {
        
    },
    created() {

    },
    mounted() {

    },
    methods: {
        handleSubmit(agentForm) { //后台提交
			console.log(agentForm)
			this.loading = true; //防重复
			this.$api.post('export/deal_order_data', agentForm, res => {
				let that = this;
				if (res.code == 0) {
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
						onClose() {
							that.loading = false;
							// that.$router.back();
						}
					});
				} else {
					this.$message({
						type: 'error',
						message: res.msg,
						duration: 1500,
						onClose() {
							that.loading = false;
						}
					});
				}
			})
        },
        handleImgLoading() { // 上传文件时加载loading
            this.imgLoading = true;
        },
		deletebillInfoImgs(index){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {let in1=this.agentForm.billInfoImgs.findIndex ((v, i) => {if (index==i) {return true;}});
			    this.agentForm.billInfoImgs.splice(in1, 1)
			}).catch(() => {})
		},
		deletetradeProImgs(index){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {let in1=this.agentForm.tradeProImgs.findIndex ((v, i) => {if (index==i) {return true;}});
			    this.agentForm.tradeProImgs.splice(in1, 1)
			}).catch(() => {})
		},
		deletetradeCardFrontImgs(index){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {let in1=this.agentForm.tradeCardFrontImgs.findIndex ((v, i) => {if (index==i) {return true;}});
			    this.agentForm.tradeCardFrontImgs.splice(in1, 1)
			}).catch(() => {})
		},
		deletetradeCardBackImgs(index){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {let in1=this.agentForm.tradeCardBackImgs.findIndex ((v, i) => {if (index==i) {return true;}});
			    this.agentForm.tradeCardBackImgs.splice(in1, 1)
			}).catch(() => {})
		},
		deletecertificateFrontImgs(index){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {let in1=this.agentForm.certificateFrontImgs.findIndex ((v, i) => {if (index==i) {return true;}});
			    this.agentForm.certificateFrontImgs.splice(in1, 1)
			}).catch(() => {})
		},
		deletecertificateBackImgs(index){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {let in1=this.agentForm.certificateBackImgs.findIndex ((v, i) => {if (index==i) {return true;}});
			    this.agentForm.certificateBackImgs.splice(in1, 1)
			}).catch(() => {})
		},
        handlebillInfoImgsImg(res) {this.upImg({ res, img: 'billInfoImgs' });},
        handletradeProImgsImg(res) { this.upImg({ res, img: 'tradeProImgs' }); },
        handletradeCardFrontImgsImg(res) { this.upImg({ res, img: 'tradeCardFrontImgs' }); },
        handletradeCardBackImgsImg(res) { this.upImg({ res, img: 'tradeCardBackImgs' }); },
		handlecertificateFrontImgsImg(res) { this.upImg({ res, img: 'certificateFrontImgs' }); },
		handlecertificateBackImgsImg(res) { this.upImg({ res, img: 'certificateBackImgs' }); },
        upImg(res) { //公用
			if(this.agentForm[res.img].length==4){
				this.$message.error("最多4张");
				this.imgLoading = false;
			}else{ 
				let resData = res.res;
				if (resData.code === 0) {
					this.agentForm[res.img] = this.agentForm[res.img].concat([resData.data.file_url]); //展示路径
				} else {
					//错误提示
					this.$message.error(res.msg);
				}
				this.imgLoading = false;
			}
        },
    }
}
</script>

<style scoped lang="scss">
.el-form-item {
    margin-bottom: 22px;
}
.m-title {
    color: #303133;
    font-size: 14px;
    font-weight: 700;
    padding-left: 10px;
    margin: 10px 0;
    border-left: 4px solid #409eff;
}
.line {
    text-align: center;
}
::v-deep .el-input-group__append {
    color: #ffffff;
    font-size: 12px;
    background-color: #409eff;
}
.el-form-item__content .el-input-group {
    vertical-align: middle;
	display: -webkit-inline-box;
}
.avatar-uploader {
    width: 200px;
    height: 130px;
    border-radius: 10px;
    overflow: hidden;
}
::v-deep .avatar-uploader .el-upload {
	display: contents;
    width: 100%;
    height: 100%;
}
.avatar {
	    width: 200px;
	    height: 130px;
}
</style>
